<template>
  <section class="content-block">
    <div class="max-w-7xl mx-auto px-4 py-8">
      <div class="space-y-8">
        <!-- Title and Content Section -->
        <div class="prose max-w-none">
          <h1 class="text-[#9900f1] text-3xl font-bold mb-6">
            {{ content.title }}
          </h1>
          <div
            v-html="renderedContent"
            class="text-font-primary space-y-4"
          ></div>
        </div>

        <!-- Map Section -->
        <div
          v-if="content.iframeUrl"
          class="w-full h-[100vh] rounded-lg overflow-hidden shadow-lg"
        >
          <iframe
            :src="content.iframeUrl"
            class="w-full h-full border-0"
            allowfullscreen="false"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            scrolling="no"
          ></iframe>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import MarkdownIt from "markdown-it";
import { computed } from "vue";

const md = new MarkdownIt({
  html: false, // Disable HTML tags for security
});

const props = defineProps<{
  content: {
    title: string;
    content: string;
    iframeUrl: string;
  };
}>();

// Convert markdown content to HTML
const renderedContent = computed(() => {
  return md.render(props.content.content);
});
</script>

<style lang="scss" scoped>
@use "@/assets/styles/global/rich-content.scss";

.content-block {
  @apply bg-white;
}
</style>
